import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Home from "./Theme/Home";


import AboutUs from "./Theme/AboutUs";
import ContactUs from "./Theme/ContactUs";
import PrivacyPolicy from "./Theme/PrivacyPolicy";
import TermsAndConditions from "./Theme/TermsAndConditions";
import RefundAndCancellationPolicy from "./Theme/RefundAndCacellationPolic";

function App() {
  return (
    <Router>
      <div className="App">
        {/* Navigation Menu */}
       

        {/* Page Routes */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/privacy_policy" element={<PrivacyPolicy />} />
          <Route path="/termsandconditions" element={<TermsAndConditions />} />
          <Route path="/refundandcalcellation" element={<RefundAndCancellationPolicy />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
